import React from 'react';


export function Columns({children}) {

    return (
        <div className={"row "}>

            {
                children.map(child => (
                    <div className={"col"}>
                        {child}
                    </div>
                ))
            }

        </div>
    )

}